import {
  Component,
  Input,
  ElementRef,
  ViewChild,
  AfterContentChecked,
} from "@angular/core";
import { Platform, Slides } from "ionic-angular";
import { UPLOADS } from "../../providers/api/api";

@Component({
  selector: "banner",
  templateUrl: "banner.html",
})
export class BannerComponent {
  @Input() banners: Array<{
    _id?: string;
    foto?: string;
    fotoMobile?: string;
    callToAction?: {
      titulo?: string;
      textoSuperior?: string;
      boton?: string;
      url?: string;
    };
    bannerBoton?: boolean;
    orden?: number;
  }>;
  ruta: string = UPLOADS;
  public isMobile: Boolean;

  constructor(private _platform: Platform) {
    this.isMobile = this._platform.is("mobileweb");
  }

  openBanner(url, open) {
    if (open) {
      window.location.href = url;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/banner/banner.ts